var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    fill: "#010128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 148.5,0 C 66.634,0 0.031,66.617 0.031,148.5 0.031,230.383 66.634,297 148.5,297 230.366,297 296.969,230.383 296.969,148.5 296.969,66.617 230.366,0 148.5,0 Z m 0,276.732 c -70.69,0 -128.201,-57.524 -128.201,-128.232 0,-2.528 0.082,-5.038 2.3915,-20.7195 C 39.76,60.287 89.541,20.268 148.5,20.268 c 70.69,0 128.201,57.524 128.201,128.232 0,20.358 -4.775,39.619 -19.312,66.6155 C 227.935,256.376 190.55,276.732 148.5,276.732 Z m 51.709,-128.233 c 0,-28.82 -23.197,-52.267 -51.71,-52.267 -25.081,0 -50.725043,27.98681 -50.7255,52.2645 -4.57e-4,24.27959 25.6445,52.2705 50.7275,52.2705 10.411,0 21.40672,-1.69543 35.4985,-15.718 14.34147,-14.27103 16.2095,-25.682 16.2095,-36.55 z M 148.5,180.5 c -17.338,0 -31.442,-14.355 -31.442,-32 0,-17.645 14.104,-32 31.442,-32 17.338,0 31.442,14.355 31.442,32 0,17.645 -14.104,32 -31.442,32 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.ee29b57144d88e8318099cbedf4ebd1f.svg";
export { ForwardRef as ReactComponent };